import type { AuditLogEntry } from "../types";
import { apiClient } from "./apiClient";
export const logsApi = { list: () => apiClient<AuditLogEntry[]>("/logs") };

